import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@kr/environment';
import { WalletCard } from '@kr/models';
import { OrganizationService } from '@kr/services';

import { GetUserIdsRes, GetUsersRes } from '../models';

@Injectable()
export class WalletUsersApiService {
  readonly #http = inject(HttpClient);
  readonly #organizationService = inject(OrganizationService);
  readonly #apiHost = environment.apiHost;

  getUsers(): Observable<GetUsersRes> {
    return this.#http.get<GetUsersRes>(`${this.#apiHost}/users/list/`);
  }

  getUserIds(wallet: WalletCard): Observable<GetUserIdsRes> {
    const { id: wallet_id, organizationId } = wallet;

    return this.#http.get<GetUserIdsRes>(`${this.#apiHost}/wallets/shared/${wallet_id}/`, {
      headers: this.#organizationService.getHttpHeaders(organizationId),
    });
  }

  addUsers(wallet: WalletCard, userIds: number[]): Observable<void> {
    return this.#http.post<void>(
      `${this.#apiHost}/wallets/user/add/`,
      {
        walletId: wallet.id,
        userId: userIds,
      },
      { headers: this.#organizationService.getHttpHeaders(wallet.organizationId) },
    );
  }

  removeUsers(wallet: WalletCard, userIds: number[]): Observable<void> {
    return this.#http.delete<void>(`${this.#apiHost}/wallets/user/remove/`, {
      body: {
        walletId: wallet.id,
        userId: userIds,
      },
      headers: this.#organizationService.getHttpHeaders(wallet.organizationId),
    });
  }
}
